import {
  // bootGigyaScreenRouter,
  updateGigyaScreenRouter,
} from 'actions/gigya-router-actions';
import { loadAccountInfo } from 'actions/gigya-actions';
import { initPlayer, loadPlayItemWithParameters } from 'actions/player-actions';
import { downloadContent, isOnline } from 'actions/content-actions';
import downloadAppRating from 'actions/rating-actions';
import loadFavorites from 'actions/favorites-actions';
import { getIsInMobileApp } from 'store/reducers/urlParams';

export function appBoot() {
  return async (dispatch, getState) => {
    // dispatch(bootGigyaScreenRouter());
    dispatch(loadAccountInfo());
    dispatch(initPlayer());
    if (!getIsInMobileApp(getState())) {
      dispatch(downloadContent());
      dispatch(downloadAppRating());
    }
    dispatch(isOnline());
  };
}

export function accountInfoLoaded() {
  return async (dispatch) => {
    dispatch(updateGigyaScreenRouter());
    dispatch(loadFavorites());
  };
}

export function contentDownloaded() {
  return async (dispatch) => {
    dispatch(loadPlayItemWithParameters());
  };
}
